import React from "react";
import { useParams, Link } from "react-router-dom";

const BoardNav = (props) => {
  const { board_view, board_id, lesson } = useParams();

  return (
    <ul
      className="sustain-tabs bg-white nav nav-tabs position-fixed w-100"
      style={{ top: "70px", zIndex: "3" }}
    >
      <li className="nav-item" role="presentation">
        <Link
          className={`nav-link ${board_view === "about" ? "active" : ""}`}
          to={`/board/${board_id}/about/`}
        >
          Om Change boarden
        </Link>
      </li>
      <li className="nav-item" role="presentation">
        <Link
          className={`nav-link ${
            board_view === "guide" || lesson ? "active" : ""
          }`}
          to={`/board/${board_id}/guide/`}
        >
          Guide
        </Link>
      </li>
      <li className="nav-item" role="presentation">
        <Link
          className={`nav-link ${
            board_view === "board" || (!board_view && !lesson) ? "active" : ""
          }`}
          to={`/board/${board_id}/board/`}
        >
          Change board
        </Link>
      </li>
      { props.board?.chart && props.board?.chart !== "" &&
        <li className="nav-item" role="presentation">
          <Link
            className={`nav-link ${board_view === "chart" ? "active" : ""}`}
            to={`/board/${board_id}/chart/`}
          >
            Board Chart
          </Link>
        </li>
      }
      <li className="nav-item" role="presentation">
        <Link
          className={`nav-link ${board_view === "settings" ? "active" : ""}`}
          to={`/board/${board_id}/settings/`}
        >
          Inställningar
        </Link>
      </li>
    </ul>
  );
};

export default BoardNav;
